import * as Sentry from '@sentry/vue';
import { App } from 'vue';

import { parseEnvVariable } from '~/utils';

/***
 we completely disabled tracing which allows to track front end and backend related transactions
 transaction tracking is extremely expensive
 */
export function setupSentry(app: App<Element>) {
	// compute transaction trace propagation target
	// const backendURL = import.meta.env.SILAE_BACKEND_URL;

	if (parseEnvVariable(import.meta.env.SILAE_ENABLE_SENTRY)) {
		Sentry.init({
			app,
			// TODO insert Sentry DSN
			dsn: null,
			integrations: [
				/* Sentry.browserTracingIntegration(), Sentry.replayIntegration() */
			],
			environment: import.meta.env.SILAE_ENVIRONMENT,
			release: __APP_VERSION__,
			// Performance Monitoring
			enableTracing: false,
			tracesSampleRate: 0 //  0% of the transactions captured between 0 - 1
			// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
			// tracePropagationTargets: ['localhost', backendURL]
			// Session Replay
			// replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
			// replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
		});
	}
}

export function initSentryUserContext(email: string, username: string): void {
	if (parseEnvVariable(import.meta.env.SILAE_ENABLE_SENTRY)) {
		Sentry.setUser({ email, username });
	}
}

export function clearSentryUserContext(): void {
	if (parseEnvVariable(import.meta.env.SILAE_ENABLE_SENTRY)) {
		Sentry.setUser(null);
	}
}
